import { useState } from 'react';

import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useSharedResourcesStore } from 'store/sharedResources.store';

import { useSharedResourcesAvailability } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramCriticalAnalysis/queries/sharedResourcesAvailabilityQuery';
import { IClusterItem } from 'components/widgets/Gantt/components/ganttChart.types';

export const useSharedResourcesAvailabilityProvider = ({ widgetId, latestVersionId, localFilters }) => {
    const isInPinboard = Boolean(widgetId);

    const [cluster, setCluster] = useCLusterState();
    const [isCriticalPath, setIsCriticalPath] = useState<boolean>(false);

    const source = isInPinboard ? localFilters : { cluster, isCriticalPath };

    return {
        ui: {
            state: getState({ source }),
            pills: useGetPills(source, widgetId, latestVersionId),
            setters: {
                setCluster,
                setIsCriticalPath,
            },
            isInPinboard,
        },
        api: {
            getSharedResourcesAvailability: useSharedResourcesAvailability({ metaDataId: latestVersionId }),
        },
    };
};

const useGetPills = (source, widgetId, latestVersionId) => {
    const pillsData = {
        cluster: source?.cluster?.label,
        isCriticalPath: source?.isCriticalPath,
    };

    const { pillsList: pills } = useGlobalFiltersHook({
        widgetId,
        latestVersionId,
        source: pillsData,
    });

    return pills;
};

const getState = ({ source }) => {
    return {
        //local
        cluster: source?.cluster,
        isCriticalPath: source?.isCriticalPath,
    };
};

const useCLusterState = (): [IClusterItem | null, (value: IClusterItem | null) => void] => {
    //cluster state that is connected to persistent store
    const [cluster, setCluster] = useState<IClusterItem | null>(null);
    const { update } = useSharedResourcesStore();

    const handleClusterSelect = (value: IClusterItem | null) => {
        setCluster(value);
        update({ cluster: value });
    };

    return [cluster, handleClusterSelect];
};
